export default __webpack_public_path__ + "static/media/aws-s3.6d3384ea.svg";